import React from 'react';
import Icon from '@mdi/react';
import { mdiBankTransfer, mdiCheckCircle, mdiAlertCircle } from '@mdi/js';
import { formatCurrencyFromMinor } from '../../utils/currency';
import './PayoutHistoryTable.css';

/**
 * PayoutHistoryTable — Displays payout history grouped by payout date.
 */
function PayoutHistoryTable({ payouts }) {

  const formatDate = (date) => {
    if (!date) return '—';
    return new Date(date).toLocaleDateString('en-AU', {
      weekday: 'short',
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  };

  if (payouts.length === 0) {
    return (
      <div className="payout-history-empty">
        <Icon path={mdiBankTransfer} size={1.5} />
        <p>No payouts yet</p>
        <span>Payouts appear here after transactions have been paid out to your bank.</span>
      </div>
    );
  }

  return (
    <div className="payout-history-container">
      <div className="payout-history-scroll">
        <table className="payout-history-table">
          <thead>
            <tr>
              <th>Payout Date</th>
              <th>Transactions</th>
              <th>Amount</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {payouts.map((payout, index) => (
              <tr key={index}>
                <td className="payout-date">{formatDate(payout.date)}</td>
                <td className="payout-count">
                  {payout.transactionCount} transaction{payout.transactionCount !== 1 ? 's' : ''}
                </td>
                <td className="payout-amount">
                  {formatCurrencyFromMinor(payout.amount, payout.currency)}
                </td>
                <td>
                  <span className={`payout-status ${payout.status === 'paid' ? 'status-paid' : 'status-failed'}`}>
                    <Icon
                      path={payout.status === 'paid' ? mdiCheckCircle : mdiAlertCircle}
                      size={0.7}
                    />
                    <span>{payout.status === 'paid' ? 'Paid' : 'Failed'}</span>
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default PayoutHistoryTable;
